import styles from './styles.module.css';

const VideoDestacado = (props) => {

    const {
        title,
        text,
        url,
        isPreview,
        clase
    } = props;

    let urlIframe;
    let url_share = url;

    if (url.indexOf('youtube') !== -1) {
        let regexYoutube = /(?:youtube\.com\/(?:[^\/]+\/.+\/|(?:v|e(?:mbed)?)\/|(?:v|l(?:ive)?)\/|.*[?&]v=)|youtu\.be\/)([^"&?\/\s]{11})/gi;
        const idVideo = regexYoutube.exec(url);
        urlIframe = `https://www.youtube.com/embed/${idVideo[1]}?autoplay=1&mute=1`;
        url_share = `https://www.youtube.com/watch?v=${idVideo[1]}`;
    }

    if (url.indexOf('facebook') !== -1) {
        urlIframe = "https://www.facebook.com/plugins/video.php?height=314&href=" + encodeURI(url) + "&show_text=false&t=0";
    }

    if (url.indexOf('livestream.com') !== -1) {
        urlIframe = url;
    }

    if (url.indexOf('jwplayer') !== -1) {
        urlIframe = url;
    }

    if (url.indexOf('habilitado-ellitoral') !== -1) {
        urlIframe = url;
    }

    return (
        <div className={`${styles.principal} ${styles[clase || 'azul']}`}>

            <div className={isPreview ? styles['preview-containter'] : styles['container-video']}>

                <div className={styles['embebed-video']}>
                    <iframe
                        src={urlIframe}
                        width="100%"
                        scrolling="no"
                        frameBorder="0"
                        allowFullScreen={true}
                        loading="lazy"
                        allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share;"
                        title={title}
                    />
                </div>

                <div className={styles['center']}>

                    <h2>{title}</h2>

                    <div className={styles['compartir-video-nota']}>

                        <a href={'https://api.whatsapp.com/send?text=No%20te%20pierdas%20esta%20noticia%20de%20El%20Litoral:%20' + url_share + '%3Futm_medium%3Dwhatsapp%20-%20Envianos%20tu%20noticia%20a:%20%2B5493426305344'}>
                            <img
                                src="https://www.ellitoral.com/collections/utiles-diseno/whatsapp___68bb31488c1691001ae0e286.png"
                                width={30}
                                height={30}
                                style={clase === 'azul' ? { filter: 'invert(1)' } : {}}
                                alt="Whatsapp"
                            />
                        </a>

                        <a href={`http://twitter.com/share?url=${url_share}`} target="_blank" rel="noreferrer noopener">
                            <img
                                src="https://www.ellitoral.com/collections/utiles-diseno/x___68bb314875e1840019ae03d4.png"
                                width={30}
                                height={30}
                                style={clase === 'azul' ? { filter: 'invert(1)' } : {}}
                                alt="X"
                            />
                        </a>

                        <a href={`https://www.facebook.com/sharer.php?u=${url_share}`} target="_blank" rel="noreferrer noopener">
                            <img
                                src="https://www.ellitoral.com/collections/utiles-diseno/facebook___68bb31478c1691001ae0e285.png"
                                width={30}
                                height={30}
                                style={clase === 'azul' ? { filter: 'invert(1)' } : {}}
                                alt="Facebook"
                            />
                        </a>

                    </div>

{/*
<div className={styles['mas-notas-container']}>
    <button
        className={styles['mas-notas-btn']}
        onClick={() => window.location.href = '/noticias'}
    >
        MÁS NOTAS
    </button>
</div>
*/}

                </div>

            </div>

        </div>
    );
};

export default VideoDestacado;